import React, { FC, useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { historyActions } from "redux/_core/history";
import { IStore } from "redux/store";
import { logActions, logSelectors } from "redux/app/logs";
import TemplateRenderer from "components/app/vessel/onboard/reports/TemplateRenderer";

type ReportOwnProps = {
	cnrId: string;
};

type ReportProps = PropsFromRedux & ReportOwnProps;

const Report: FC<ReportProps> = (props) => {
	const { cnrId, jobToLoadReport } = props;
	const setIsDragRef = useRef((value: boolean) => {});
	const errorShownRef = useRef(false);
	const errorMessageRef = useRef("");

	useEffect(() => {
		if (cnrId) {
			props.loadReport(cnrId);
		}

		return () => {
			props.clearSelectedReport();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cnrId]);

	if (!cnrId) {
		return (
			<div className="flex-1 flex justify-center items-center">
				No CNR report found.
			</div>
		);
	}

	if (jobToLoadReport.isError && !errorShownRef.current) {
		errorShownRef.current = true;
		errorMessageRef.current = jobToLoadReport?.message ?? "";
	}

	if (errorShownRef.current) {
		console.log(`cnrId is ${cnrId}`);
		return (
			<div className="absolute z-50 left-1/2 -translate-x-1/2 top-1/2 transform -translate-y-1/2 bg-white p-8 rounded-lg shadow-xl max-w-md w-full mx-4">
				<div className="flex items-center justify-center mb-4">
					<div className="bg-red-100 rounded-full p-3">
						<span className="bp3-icon bp3-icon-error text-2xl text-red-600" />
					</div>
				</div>
				<h2 className="text-xl font-bold text-gray-800 text-center mb-2">
					Error Loading CNR Report
				</h2>
				<p className="text-gray-600 text-center mb-4">
					There was an issue loading the report with CNR ID:
				</p>
				<div className="bg-gray-100 p-4 rounded-md mb-4">
					<p className="font-mono text-sm break-all">{cnrId}</p>
				</div>
				{errorMessageRef?.current && (
					<div className="mt-4">
						<p className="text-sm font-medium text-gray-700 mb-1">
							Error Details:
						</p>
						<p className="text-sm text-gray-600 bg-gray-100 p-3 rounded-md overflow-auto max-h-32">
							{errorMessageRef.current}
						</p>
					</div>
				)}
				<div className="mt-6 flex justify-center">
					<button
						onClick={() => window.location.reload()}
						className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
					>
						Reload Page
					</button>
				</div>
			</div>
		);
	}

	return (
		<div className="shadow rounded">
			<TemplateRenderer
				setIsDragRef={setIsDragRef}
				onClose={function onClose() {
					// Do nothing.
				}}
				isIdBasedCNR={true}
			/>
		</div>
	);
};

function mapStateToProps(store: IStore, ownProps: ReportOwnProps) {
	const reportStore = store.app.logs;
	const jobToLoadReport = logSelectors.jobToLoadSelectedReport(reportStore);
	return {
		jobToLoadReport,
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {
		goto(route: string) {
			return dispatch(historyActions.push("Dashboard", route));
		},
		loadReport(reportId: string) {
			dispatch(logActions.commands.singleReportLoad(reportId));
		},
		clearSelectedReport() {
			dispatch(logActions.document.clearSelectedReport());
		},
	};
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Report);
